// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".viewer-prev.viewer-prev,\n.viewer-next.viewer-next {\n  display: block !important;\n}\n", ""]);
// Exports
module.exports = exports;
